import * as React from 'react';
import MaterialCommunityIcon from '../components/MaterialCommunityIcon';
export const {
  Provider,
  Consumer
} = /*#__PURE__*/React.createContext({
  icon: MaterialCommunityIcon
});
//# sourceMappingURL=settings.js.map